module.exports = __webpack_public_path__ + "img/list-2-blur.7938d87c.png";